import Header from "../Header/Header";
import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import privateRequest from "../commonApi/CommonApi";
import moment from "moment";
import Swal from "sweetalert2";

function Dashboard({ userData }) {
  const navigate = useNavigate();
  const [tokenPresent, setTokenPresent] = useState(false);
  const [year, setYear] = useState(moment(new Date()).format("YYYY"));
  const [month, setMonth] = useState(moment(new Date()).format("MM"));
  const [year1, setYear1] = useState(moment(new Date()).format("YYYY"));
  const [month1, setMonth1] = useState(moment(new Date()).format("MM"));
  const [PCgroup, setPCgroup] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const [selectedGroup1, setSelectedGroup1] = useState();
  const [totalSp, setTotalSp] = useState([]);
  const [statistics, setStatistics] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    } else {
      setTokenPresent(true);
    }
  }, []);
  console.log("statistics", statistics);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setSelectedGroup(response?.data?.data?.ParentGroup[0]?.PCGName);
      setSelectedGroup1(response?.data?.data?.ParentGroup[0]?.PCGName);
      setPCgroup(response?.data?.data?.ParentGroup);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        // text: "Error creating Order",
        text: error.response?.data?.message,
      });
    }
  };
  useEffect(() => {
    getAllDocumentData();
  }, []);

  const getServiceProvidersData = async () => {
    if (!selectedGroup || !year) return;
    let data = {
      year: year,
      month: month,
      PCGName: selectedGroup,
    };
    try {
      const response = await privateRequest.post(
        `ServiceProvider/AllProvider`,
        data
      );
      console.log("service providers", response.data.data);
      setTotalSp(response.data.data);
    } catch (error) {
      console.error("Error fetching providers:", error);
    }
  };

  const getServiceStatisticksData = async () => {
    if (!selectedGroup1 || !year1) return;
    let data = {
      PCGName: selectedGroup1,
      year: year1,
      month: month1,
    };
    try {
      const response = await privateRequest.post(`jobs/AllcountData`, data);
      console.log("service providers", response.data.data);
      setStatistics(response.data);
    } catch (error) {
      console.error("Error fetching providers:", error);
    }
  };

  useEffect(() => {
    getServiceProvidersData();
  }, [selectedGroup, year, month]);

  useEffect(() => {
    getServiceStatisticksData();
  }, [selectedGroup1, year1, month1]);
  return (
    <>
      <main className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">
                        Hi {userData ? userData.name : "Guest"}, Welcome to
                        Experts4u
                      </span>
                    </p>
                  </div>
                </header>
                <div className="page-section">
                  <div className="row res-teb ">
                    <div className="col-lg-12 ">
                      <div className="card card-ot">
                        <div className="card-header mb-0">
                          <h2 className="card-title mb-0">
                            <div className="row ">
                              <div className="col-lg-7 d-flex align-items-center">
                                <p className="card-title mb-3 mb-md-0">
                                  Common statistics
                                </p>
                              </div>

                              <div className="col-lg-5 d-flex text-left">
                                <select
                                  className="form-control form-control w-50 ml-auto mr-2"
                                  onChange={(e) => {
                                    setSelectedGroup1(e.target.value);
                                  }}
                                  value={selectedGroup1}
                                >
                                  {PCgroup?.map((group) => {
                                    return <option>{group.PCGName}</option>;
                                  })}
                                </select>

                                <select
                                  className="form-control form-control w-50 ml-auto mr-2"
                                  onChange={(e) => {
                                    setYear1(e.target.value);
                                  }}
                                  value={year1}
                                >
                                  <option>2022</option>
                                  <option>2023</option>
                                  <option>2024</option>
                                  <option>2025</option>
                                  <option>2026</option>
                                  <option>2027</option>
                                  <option>2028</option>
                                  <option>2029</option>
                                  <option>2030</option>
                                </select>

                                <select
                                  className="form-control form-control w-50 ml-auto"
                                  onChange={(e) => {
                                    setMonth1(e.target.value);
                                  }}
                                  value={month1}
                                >
                                  <option value="">Select</option>
                                  <option value="01">Jan</option>
                                  <option value="02">Feb</option>
                                  <option value="03">Mar</option>
                                  <option value="04">Apr</option>
                                  <option value="05">May</option>
                                  <option value="06">Jun</option>
                                  <option value="07">Jul</option>
                                  <option value="08">Aug</option>
                                  <option value="09">Sep</option>
                                  <option value="10">Oct</option>
                                  <option value="11">Nov</option>
                                  <option value="12">Dec</option>
                                </select>
                              </div>
                            </div>
                          </h2>
                        </div>
                        <div className="card-body main-card">
                          <div className="row justify-content-center mt-0 mt-md-4 card-start">
                            <div className="col-lg-2 col-md-3 col-6  mr-lg-3 mr-0 mb-2 mb-lg-4 ">
                              <Link to="/todaysjob">
                                <div className="card-head card-head1">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5>Today's Job</h5>
                                    <div className="icon">
                                      <img
                                        style={{ width: "25px" }}
                                        src={require("../photos/box.png")}
                                      />
                                    </div>
                                  </div>
                                  <h4>{statistics.todayJobs || 0}</h4>
                                </div>
                              </Link>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6 mr-lg-3 mr-0 mb-2 mb-lg-4">
                              <Link to="/upcomingjob">
                                <div className="card-head card-head2">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5>Upcoming Jobs</h5>
                                    <div className="icon">
                                      <img
                                        style={{ width: "25px" }}
                                        src={require("../photos/box.png")}
                                      />
                                    </div>
                                  </div>
                                  <h4>{statistics?.upcomingJobs || 0}</h4>
                                </div>
                              </Link>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6  mr-lg-3 mr-0 mb-2 mb-lg-4">
                              <div className="card-head card-head3">
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5>Closed Job</h5>
                                  <div className="icon">
                                    <img
                                      style={{ width: "25px" }}
                                      src={require("../photos/box.png")}
                                    />
                                  </div>
                                </div>
                                <h4>{statistics?.totalClose || 0}</h4>
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6  mr-lg-3 mr-0 mb-2 mb-lg-4">
                              <Link to="/canceledjob">
                                <div className="card-head card-head5">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5>Canceled Job</h5>
                                    <div className="icon">
                                      <img
                                        style={{ width: "25px" }}
                                        src={require("../photos/box.png")}
                                      />
                                    </div>
                                  </div>
                                  <h4>{statistics?.totalCancel || 0}</h4>
                                </div>
                              </Link>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6  mr-lg-3 mr-0  mb-2 mb-lg-4">
                              <div className="card-head card-head5">
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5>Escalation Job</h5>
                                  <div className="icon">
                                    <img
                                      style={{ width: "25px" }}
                                      src={require("../photos/box.png")}
                                    />
                                  </div>
                                </div>
                                <h4>{0}</h4>
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6  mr-lg-3 mr-0 mb-2 mb-lg-4">
                              <div className="card-head card-head4">
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5>Total Revenue</h5>
                                  <div className="icon">
                                    <img
                                      style={{ width: "25px" }}
                                      src={require("../photos/box.png")}
                                    />
                                  </div>
                                </div>
                                <h4>₹ {statistics?.totalRevenue || 0}</h4>
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6 mb-2 mb-lg-4">
                              <div className="card-head card-head1">
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5>Avg. Ticket Size</h5>
                                  <div className="icon">
                                    <img
                                      style={{ width: "25px" }}
                                      src={require("../photos/box.png")}
                                    />
                                  </div>
                                </div>
                                <h4>{statistics?.avgTicketSize || 0}</h4>
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6 mb-2 mb-lg-4">
                              <Link to="/serviceProvider">
                                <div className="card-head card-head1">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5>Total SP</h5>
                                    <div className="icon">
                                      <img
                                        style={{ width: "25px" }}
                                        src={require("../photos/box.png")}
                                      />
                                    </div>
                                  </div>
                                  <h4>
                                    {statistics?.totalServiceProviders || 0}
                                  </h4>
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-header mb-0">
                          <h2 className="card-title mb-0">
                            <div className="row">
                              <div className="col-lg-7 d-flex align-items-center">
                                <p className="card-title mb-3 mb-md-0">
                                  SP Performance
                                </p>
                              </div>
                              <div className="col-lg-5 d-flex text-left">
                                <select
                                  className="form-control form-control w-50 ml-auto mr-2"
                                  onChange={(e) => {
                                    setSelectedGroup(e.target.value);
                                  }}
                                  value={selectedGroup}
                                >
                                  {PCgroup?.map((group) => {
                                    return <option>{group.PCGName}</option>;
                                  })}
                                </select>

                                <select
                                  className="form-control form-control w-50 ml-auto mr-2"
                                  id="cmbyear_sp"
                                  onChange={(e) => {
                                    setYear(e.target.value);
                                  }}
                                  value={year}
                                >
                                  <option>2022</option>
                                  <option>2023</option>
                                  <option>2024</option>
                                  <option>2025</option>
                                  <option>2026</option>
                                  <option>2027</option>
                                  <option>2028</option>
                                  <option>2029</option>
                                  <option>2030</option>
                                </select>

                                <select
                                  className="form-control form-control w-50 ml-auto"
                                  id="cmbMonthName_sp"
                                  onChange={(e) => {
                                    setMonth(e.target.value);
                                  }}
                                  value={month}
                                >
                                  <option value="">Select</option>
                                  <option value="01">Jan</option>
                                  <option value="02">Feb</option>
                                  <option value="03">Mar</option>
                                  <option value="04">Apr</option>
                                  <option value="05">May</option>
                                  <option value="06">Jun</option>
                                  <option value="07">Jul</option>
                                  <option value="08">Aug</option>
                                  <option value="09">Sep</option>
                                  <option value="10">Oct</option>
                                  <option value="11">Nov</option>
                                  <option value="12">Dec</option>
                                </select>
                              </div>
                            </div>
                          </h2>
                        </div>
                        <div
                          className="card-body table-responsive"
                          style={{ borderradius: "0!important" }}
                        >
                          <table className="w-100 table-sm table-striped">
                            <thead className="bg-primary text-white">
                              <tr>
                                <th>SP Name</th>
                                <th>Jobs</th>
                                <th>Revenue</th>
                                <th>Esclation</th>
                                <th>Penalty</th>
                                <th>Rating</th>
                              </tr>
                            </thead>
                            <tbody id="sp_performance">
                              {totalSp.length > 0 &&
                                totalSp.map((item, index) => {
                                  return (
                                    <tr>
                                      <td className="font-weight-bold">
                                        {item?.name}
                                      </td>
                                      <td>{item?.jobCount}</td>
                                      <td>₹ {Number(item?.totalPayableCharges || 0)}</td>
                                      <td>{item?.acceleration}</td>
                                      <td>₹ {Number(item?.penalty || 0)}</td>
                                      <td>0</td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Dashboard;
